import { Injectable } from '@angular/core';
import { UtilFunctions } from '../util-functions';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor() { }

  isUserLoggedIn() {
    let user = JSON.parse(UtilFunctions.getLocalStorage('user'));
    console.log(!(user === null))
    return !(user === null)
  }

  logOut() {
    sessionStorage.removeItem('username')
  }
}